// @flow
import type { Alert } from '../types';
import * as constants from '../constants/alertConstants';

type LoadAlertsAction = {|
    type: typeof constants.LOAD_ALERTS,
    data: $ReadOnlyArray<Alert>
|};

type SetAlertAction = {|
    type: typeof constants.SET_ALERT,
    data: Alert
|};

type UnsetAlertAction = {|
    type: typeof constants.UNSET_ALERT,
    data: Alert
|};

export type AlertAction =
    | LoadAlertsAction
    | SetAlertAction
    | UnsetAlertAction;

const alertActions = {
    loadAlerts: (alerts: $ReadOnlyArray<Alert>): LoadAlertsAction => ({
        type: constants.LOAD_ALERTS,
        data: alerts
    }),

    setAlert: (alert: Alert): SetAlertAction => ({
        type: constants.SET_ALERT,
        data: alert
    }),

    unsetAlert: (alert: Alert): UnsetAlertAction => ({
        type: constants.UNSET_ALERT,
        data: alert
    })
};

export default alertActions;